<template>
  <div class="container">
    <el-page-header class="page-header" @back="goBack" content="医生认证">
    </el-page-header>
    <el-form :model="info" label-width="100px" label-position="left" class="form">
        <el-form-item label="*医生姓名">
            <el-input v-model="info.doctorName" autocomplete="off" placeholder="请输入姓名" @keyup.enter.native="submit"></el-input>
        </el-form-item>
        <el-form-item label="*医生性别">
            <el-radio-group v-model="info.doctorSex">
                <el-radio-button class="radio-button-one" label="1" size="medium">男</el-radio-button>
            </el-radio-group>
            <el-radio-group v-model="info.doctorSex">
                <el-radio-button label="0" size="medium">女</el-radio-button>
            </el-radio-group>
        </el-form-item>
        <el-form-item label="*医生电话">
            <el-input v-model="info.doctorPhonNo" autocomplete="off" placeholder="请输入手机号码" @keyup.enter.native="submit"></el-input>
        </el-form-item>
        <el-form-item label="医生身份证">
            <el-input v-model="info.idNo" autocomplete="off" placeholder="请输入身份证号码" @keyup.enter.native="submit"></el-input>
        </el-form-item>
         <el-form-item label="*行医资格证">
             <el-input v-model="info.doctorCertNo" autocomplete="off" placeholder="请输入行医资格证号码" @keyup.enter.native="submit"></el-input>
         </el-form-item>
         <el-form-item class="form-file" label="*资格证上传">
            <el-upload
            :action="uploadImgUrl"
            :show-file-list="false"
            :before-upload="beforePicUpload"
            :on-success="handlePicUploadSuccess"
            :on-error='handlePicError'
            :headers="headers"
            accept=".jpg, .jpeg, .png, .gif"
            name="file"
            >
              <img
                v-if="info.doctorCertImageUrl"
                width="220px"
                height="120px"
                :src="info.doctorCertImageUrl"
                class="avatar"
              />
              <div class="upload-bg" v-if="info.doctorCertImageUrl.length == 0" >
                <i class="el-icon-plus"></i>
              </div>

          </el-upload>
         </el-form-item>
    </el-form>
    <el-button style="width: 280px;height: 45px;margin-bottom: 22px;margin-top: 50px;" round type="primary" :loading="submitLoading" @click="submit">提  交</el-button>
  </div>
</template>
<script>
  import {checkIdCard} from '../../js/checkIdCard.js'
  export default {
    data() {
      return {
        info: {
          doctorName:'',
          doctorSex:"1",
          idNo:'',
          doctorPhonNo:'',
          doctorCertNo:'',
          doctorCertImageUrl:''
        },
        uploadImgUrl:'/api/common/upload',
        headers: {},
        submitLoading:false
      }
    },
    created() {
      var token = this.$cookies.get('token')
      this.headers.Authorization = "Bearer " + token
    },
    beforeRouteEnter(to,from,next){
        next(vm =>{
            vm.fromPath = from.path
        })
    },
    methods:{
      goBack(){
          this.$router.replace('/')
      },
      //对上传图片的大小、格式进行限制
      beforePicUpload(file) {
        const isJPG = file.type === "image/jpeg"
        const isJPG2 = file.type === "image/jpg"
        const isPNG = file.type === "image/png"
        const isGIF = file.type === "image/gif"
        const isLt5M = file.size / 1024 / 1024 < 5
        if (!isJPG && !isJPG2 && !isPNG && !isGIF) {
          this.$message({
              message: '只支持jpg或png格式图片',
              type: 'warning'
          });
        }
        if (!isLt5M) {
          this.$message({
              message: '请上传5MB以内的图片!',
              type: 'warning'
          })
        }
        return (isJPG || isJPG2 || isPNG || isGIF) && isLt5M;
      },
      handlePicUploadSuccess(res, file) {
        console.log(res)
        if (res.code === 200) {
          this.$message({
              message: '上传图片成功!',
              type: 'success'
          })
          this.info.doctorCertImageUrl = res.url
        }
      },
      handlePicError(err, file){
        console.log(err)
      },
      submit(){
        if(this.utils.isEmptyStr(this.info.doctorName)){
          this.$message({
            message:'请输入医生姓名',
            type:'warning'
          })
          return
        }
        if(this.utils.isEmptyStr(this.info.doctorPhonNo)){
          this.$message({
            message:'请输入医生电话',
            type:'warning'
          })
          return
        }
        if(!this.utils.isEmptyStr(this.info.idNo)){
          var ret = checkIdCard(this.info.idNo)
          if(ret.status != '0'){
            this.$message({
              message:ret.message,
              type:'warning'
            })
            return
          }
        }
        
        if(this.utils.isEmptyStr(this.info.doctorCertNo)){
          this.$message({
            message:'请输入从医资格证号',
            type:'warning'
          })
          return
        }
        if(this.utils.isEmptyStr(this.info.doctorCertImageUrl)){
          this.$message({
            message:'请上传从医资格证',
            type:'warning'
          })
          return
        }
        this.submitLoading = true
        this.wjtHttp.post(this,'/api/doctor/v1/person/add',this.info,false,(res)=>{
          this.submitLoading = false
            var data = res.data
            if(data.code == 200){
                this.$message({
                    message:'申请成功',
                    type:'success'
                })
                this.$store.commit('updateUserInfo',{})
                if(!this.utils.isEmptyStr(this.fromPath) && this.fromPath != '/'){
                    this.$router.go(-1)
                }else{
                    this.$router.replace('/')
                }
            }else{
                this.$message({
                    message:(data.msg&&data.msg.length > 0)?data.msg:'申请失败，请联系管理员',
                    type:'error'
                })
            }
        },(err)=>{
            console.log(err)
            this.submitLoading = false
        })
      }
    }
  }
</script>
<style scoped>
.container{
    width: 1000px;
    height: auto;
    display: flex;
    margin: 0px auto;
    flex-direction: column;
    align-items: center;
    overflow: auto;
}
.radio-button-one{
  margin-right: 50px;
}
.form{
    width: 450px;
    margin-top: 50px;
}
.page-header{
    width: 1000px;
    margin-top: 30px;
    color: #333333;
    font-size: 20px;
}
.page-header >>> div{
    color:#333333;
    font-size: 20px;
}
.form-file{
  margin-top: 60px;
}
.upload-bg{
  width: 140px;
  height: 100px;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  border-style: solid;
  border-width: 1px;
  background: #F9F9F9;
  border-color: #E4E4E4;
}
.avater{

}
</style>
